export default "__VITE_ASSET__DQgsHlT8__"